module.exports = __webpack_public_path__ + "static/privat-29c03e16857f9bf38877128643fef0e8.mp4";